<template>
    <div class="about">
        <div class="pg-header">
            <div><label class="title">补抓记录</label></div>
            <div class="algr">
                <div class="pg-nav">
                    <i class="icon-home"></i>
                    <span>系统管理</span>|
                    <span>数据管理</span>|
                    <span>补抓记录</span>
                </div>
            </div>
        </div>

        <div class="table-wrap">
            <el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border
                :data="list.data" v-loading="isLoading" >
                
                <el-table-column prop="methodName" label="补抓类型"></el-table-column>
                <el-table-column  label="补抓时间" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.startTime&&scope.row.endTime">{{scope.row.startTime+'--'+scope.row.endTime}}</span>
                        <span v-else>——</span>
                    </template>
                </el-table-column>
                <el-table-column label="补抓状态" >
                    <template slot-scope="scope">
                        <span>{{{0:'未同步',1:'待同步',2:'同步中',3:'同步成功',4:'同步失败',5:'查询失败'}[scope.row.syncStatus]}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="syncTime" label="操作时间"> </el-table-column>
                <el-table-column prop="reviserName" label="操作人"> </el-table-column>
            </el-table>
            <div class="pagination">
                <el-row>
                    <el-col :span="12">
                        <div class="record">当前是第<span v-text="(filter.pageNumber - 1) * filter.pageSize + 1"></span>条至第<span
                                v-text="Math.min(list.total, (filter.pageNumber - 1) * filter.pageSize + filter.pageSize)"></span>数据
                        </div>
                        <div class="record">总计<span v-text="list.total"></span>条记录</div>
                    </el-col>
                    <el-col :span="12" style="text-align: right;">
                        <el-pagination :disabled="isLoading" layout="sizes, prev, pager, next"
                            :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]" prev-text="上一页" next-text="下一页"
                            :current-page="list.current" :page-size="filter.pageSize" :total="list.total"
                            @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>
  
<script>
import api from '@/service/api.js';
import dayjs from 'dayjs';

export default {
    data() {
        return {
            list: {
                current: 1,
                total: 0,
                pageSize: 0,
                data: null
            },
            filter: {
                pageNumber: 1,
                pageSize: 10,
            },
            isLoading:false,
        }
    },
    created() {
        this.loadList();
    },
    mounted() {
        // 监听页面显示隐藏
        document.addEventListener('visibilitychange', this.handleVisiable)
    },
    destroyed() {
        document.removeEventListener('visibilitychange', this.handleVisiable)
    },
    methods: {
        async loadList() {
            this.isLoading = true;
            let res = await api.getLogList(this.filter);
            if (res.code == 500) { return this.$router.push({ name: 'Login', query: { r: location.href } }); }

            this.list.total = +res.total;
            this.list.current = this.filter.pageNumber;
            this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
            if (res.data) {
				res.data.forEach((item)=>{
                    let obj = JSON.parse(item.inputParams);
                    if(obj.startTime||obj.endTime){
                        item.startTime = dayjs(obj.startTime).format('YYYY-MM-DD HH:mm:ss');
                        item.endTime = dayjs(obj.endTime).format('YYYY-MM-DD HH:mm:ss');
                    }
				})
				this.list.data = res.data;
			}
            this.isLoading = false;
        },
        handleSizeChange(v) {
            this.filter.pageSize = v;
            this.filter.pageNumber = 1;
            this.loadList();
        },
        handleCurrentChange(v) {
            this.filter.pageNumber = v;
            this.loadList();
        },
        handleVisiable(e) {
            // 关闭新开页面，回到列表页，刷新列表数据
            if (e.target.visibilityState == "visible") {
                this.loadList()
            }
        },
    }
}
</script>
  
<style lang="less" scoped>
@import '@/assets/style/var';

.table-wrap{
    padding: 24px;
}
</style>
  